import React, {
  useEffect,
  useRef,
  useState,
  FunctionComponent,
  MouseEvent,
} from 'react';
import classnames from 'classnames';

import { manageDropdownListener } from '@helpers/use_effect_callbacks';
import { sortOptions, SortOptions } from '@components/show_page/sections/view_options/helper';
import { TertiaryButton } from '@components/library/button/index';
import { ListDropdown } from '@components/library/dropdown/index';
import Toggle from '@components/common/toggle/main';
import {
  UpdateUserViewOptions,
  UserViewOptions,
  UserViewOptionsKeys,
} from '@components/show_page/sections/view_options/ViewOptionTypes';
import ViewOptionsDropdown from '@components/show_page/sections/view_options/view_options_dropdown';

import './styles/view-options-menu.scss';

const toggleSizes = {
  height: 20,
  width: 32,
  sliderDiameter: 18,
};

interface ViewOptionsProps {
  paginatePer: number;
  searchSubmitted: boolean;
  updateUserViewOptions: UpdateUserViewOptions;
  userViewOptions: UserViewOptions;
}

const ViewOptions: FunctionComponent<ViewOptionsProps> = ({
  paginatePer,
  searchSubmitted,
  updateUserViewOptions,
  userViewOptions
}) => {
  const [renderViewOptions, setRenderViewOptions] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const thisComponent = useRef();

  useEffect(() => (
    manageDropdownListener(thisComponent, renderViewOptions, setRenderViewOptions)
  ), [thisComponent, renderViewOptions, setRenderViewOptions]);

  useEffect(() => {
    setIsVisible(renderViewOptions); // make visible after element renders
  }, [renderViewOptions]);

  return (
    <div className="view-options-container">
      <div className="view-options__show-sections">
        <button
          className="show-sections-button"
          onClick={(e: MouseEvent): void => {
            e.preventDefault();
            updateUserViewOptions(UserViewOptionsKeys.ShowSections);
          }}
          type="button"
        >
          <Toggle
            sizes={toggleSizes}
            isOn={userViewOptions?.showSections}
          />
        </button>
        <p className="toggle-copy">{t('Organize by section')}</p>
      </div>
      <ListDropdown
        anchorElementLabel={t("Sort by")}
        className="view-options__sort-dropdown"
        onChange={(option: { value: SortOptions; label: string }): void => updateUserViewOptions(searchSubmitted ? UserViewOptionsKeys.SortOptionSearch : UserViewOptionsKeys.SortOption, option.value)}
        options={sortOptions(searchSubmitted)}
        value={searchSubmitted ? userViewOptions?.sortOptionSearch : userViewOptions?.sortOption}
      />
      <div className="view-options-menu" ref={thisComponent}>
        <TertiaryButton
          className={classnames(
            "view-options-menu-button",
            { active: renderViewOptions },
          )}
          onClick={(): void => setRenderViewOptions(!renderViewOptions)}
        >
          <span className="bff-grid-view" />
          {t('View Options')}
        </TertiaryButton>
        {renderViewOptions && (
          <ViewOptionsDropdown
            isVisible={isVisible}
            paginatePer={paginatePer}
            searchSubmitted={searchSubmitted}
            setRenderViewOptions={setRenderViewOptions}
            updateUserViewOptions={updateUserViewOptions}
            userViewOptions={userViewOptions}
          />
        )}
      </div>
    </div>
  );
};

export default ViewOptions;
